import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";

export class BookOfShadowsTransitionsView extends BaseView {
    protected MOBILE_SCALE: number = 1.6;
    protected BUTTON_SIZE: PIXI.Point = new PIXI.Point(240, 64);
    protected BUTTON_TEXT_STYLE: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Open Sans",
        fontStyle: FontStyle.ITALIC,
        fontSize: 34,
        fill: "#ffffff",
        fontWeight: FontWeight.EXTRA_BOLD
    });
    protected _button: NineSliceButton;
    protected _layer: ScalableLayer;
    protected readonly _completeCallback: () => void;
    private _deviceScale: number;

    /**
     * @constructs
     * @param layer
     * @param callback
     */
    protected constructor(layer: ScalableLayer, callback: () => void) {
        super();
        this._layer = layer;

        this._completeCallback = callback;
    }

    /**
     * @description To disable the continue button.
     */
    public disableButton() {
        this._button.enabled = false;
    }

    /**
     * @description To enable the continue button.
     */
    public enableButton() {
        this._button.enabled = true;
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        this._deviceScale = UserAgent.isMobile ? this.MOBILE_SCALE : 1;

        this._button = this.createButton();
    }

    /**
     * @inheritDoc
     * @param data
     */
    protected onResize(data: IResizeData): void {
        super.onResize && super.onResize(data);

        //Negate layer scaling offset.
        this.x = -this._layer.x / this._layer.scale.x;
        this.y = -this._layer.y / this._layer.scale.y;

        this._isResizeDirty = false;

        this.resizeButton();
    }

    /**
     * @description To create the continue button.
     */
    private createButton(): NineSliceButton {
        const text: string = Translation.translate("CONTINUE");
        const textStyle: TextStyleOptions = this.getScaledButtonTextStyle();
        const button = new NineSliceButton(() => this.internalCompleteCallback(), ` ${text} `, textStyle);
        button.enabled = false;
        return button;
    }

    /**
     * @description Resizing the button.
     */
    private resizeButton(): void {
        const buttonSize: PIXI.Point = new PIXI.Point(this.BUTTON_SIZE.x * this._deviceScale, this.BUTTON_SIZE.y * this._deviceScale);
        this._button.setSize(buttonSize.x, buttonSize.y, this._layer.scale.x);
        this._button.position.set(360, 620);
    }

    /**
     * @description To get button's scaled text style.
     */
    private getScaledButtonTextStyle(): TextStyleOptions {
        const style: TextStyleOptions = this.BUTTON_TEXT_STYLE;
        if (typeof style.fontSize !== 'number') {
            debugger;
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        style.fontSize = (<number>style.fontSize) * this._deviceScale;
        return style;
    }

    /**
     * @description Complete call back when button is clicked.
     */
    private internalCompleteCallback() {
        if (this._completeCallback) {
            this.disableButton();
            this._completeCallback();
        }
    }
}